const tr_TR = {
  "colorpicker.opacity-input": "Opaklık",
  "datepicker.clear-date": "Tarihi sil",
  "datepicker.next-month": "Gelecek ay",
  "datepicker.open-calendar": "Takvimi aç",
  "datepicker.previous-month": "Geçtiğimiz ay",
  "input.clear": "Girişi temizle",
  "input.hide-password": "Şifreyi gizle",
  "input.show-password": "Şifreyi göster",
  "modal.close": "Kapat",
  "multiselectchips.add-value": "‘{value}’ ekleyin",
  "multiselectchips.remove-all": "Tümünü kaldır",
  "pagination.next-page": "Sonraki sayfa",
  "pagination.previous-page": "Önceki sayfa"
};
export {
  tr_TR as default
};
//# sourceMappingURL=tr_TR.json.js.map
